import React, { FC, useEffect, useState } from 'react';
import { FormControl, FormHelperText, InputLabel, Select } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import useContact from '../../hooks/api/useContact';
import Contact from '../../interfaces/api/Contact';

interface Props {
  value?: string;
  error?: boolean;
  required?: boolean;
  helperText?: string;
  siteId: string;
  className?: any;
  onChange: (event: React.ChangeEvent<{ name?: string; value: unknown }>) => void;
}

const ContactSelect: FC<Props> = React.forwardRef<any, Props>(
  ({ onChange, className, siteId, helperText, required, value, ...props }, ref) => {
    const [contacts, setContacts] = useState<Contact[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string>();

    const { getBySite } = useContact();

    useEffect(() => {
      getBySite(siteId)
        .then((contacts) => {
          setContacts(contacts);
          setLoading(false);
        })
        .catch((e) => {
          setError(e.message);
          setLoading(false);
        });
    }, []);

    if (loading) {
      return <Skeleton height={50} />;
    }

    if (error) {
      return <div style={{ color: '#f44336' }}>{error}</div>;
    }

    return (
      <FormControl
        ref={ref}
        variant='outlined'
        className={className}
        error={props.error}
        {...props}
        required={required}
        fullWidth
      >
        <InputLabel>Contact</InputLabel>
        <Select native label='Contact *' onChange={onChange} value={value}>
          <option value='' />
          {contacts.map((contact, key) => (
            <option key={key} value={contact.id}>
              {`${contact.firstname} ${contact.lastname}`}
            </option>
          ))}
        </Select>

        {helperText && <FormHelperText>{helperText}</FormHelperText>}
      </FormControl>
    );
  }
);

export default ContactSelect;
